<template>
  <div class="sld_login">
    <div class="sld_login_header">
      <div class="content">
        <router-link tag="a" class="l_logo" :to="`/index`">
          <img class="img" :src="configInfo.main_site_logo" :onerror="defaultImg" alt />
        </router-link>
      </div>
    </div>
    <div class="sld_login_content">
      <img class="bg" :src="configInfo.main_user_logon_bg" :onerror="defaultBgImg" alt />
      <div class="login">
        <div class="login_box">
          <div class="top">
            <div class="item1">{{ L['完善信息'] }}</div>
          </div>
          <div class="center">
            <div class="item account">
              <input type="text" v-model="companyName" placeholder="请输入单位全称" class="input"
                @focus="showClose('companyName')" />
              <div data-type="userName" class="cancel" @click="clearInputVal('name')">
                <span style="color: #bbb;" class="iconfont icon-cuowu" v-show="companyName && current == 'companyName'"
                  @click="delateInput('companyName')"></span>
              </div>
            </div>
            <div class="item account">
              <input type="text" v-model="user_name" placeholder="请输入姓名" class="input"
                @focus="showClose('user_name')" />
              <div data-type="userName" class="cancel" @click="clearInputVal('name')">
                <span style="color: #bbb;" class="iconfont icon-cuowu" v-show="user_name && current == 'user_name'"
                  @click="delateInput('user_name')"></span>
              </div>
            </div>
            <div class="item account">
              <input type="text" v-model="Email" placeholder="请输入邮箱" class="input" @focus="showClose('Email')" />
              <div data-type="userName" class="cancel" @click="clearInputVal('name')">
                <span style="color: #bbb;" class="iconfont icon-cuowu" v-show="Email && current == 'Email'"
                  @click="delateInput('Email')"></span>
              </div>
            </div>
            <div class="item account">
              <el-cascader ref="cascaderAddr" v-model="addressAll" :options="areaDataArray" class="item_cascader"
                :placeholder="L['请选择所在地区']" :props="cascaderProps" clearable></el-cascader>
              <div data-type="userName" class="cancel" @click="clearInputVal('name')">
                <span style="color: #bbb;" class="iconfont icon-cuowu" v-show="addressAll && current == 'addressAll'"
                  @click="delateInput('addressAll')"></span>
              </div>
            </div>
            <div class="item account">
              <input type="text" v-model="detailAddress" placeholder="请输入详细地址" class="input"
                @focus="showClose('detailAddress')" />
              <div data-type="userName" class="cancel" @click="clearInputVal('name')">
                <span style="color: #bbb;" class="iconfont icon-cuowu"
                  v-show="detailAddress && current == 'detailAddress'" @click="delateInput('detailAddress')"></span>
              </div>
            </div>
            <div class="item account">
              <input type="text" v-model="name" :placeholder="L['请输入手机号']" class="input" @focus="showClose('name')" />
              <div data-type="userName" class="cancel" @click="clearInputVal('name')">
                <span style="color: #bbb;" class="iconfont icon-cuowu" v-show="name && current == 'name'"
                  @click="delateInput('name')"></span>
              </div>
            </div>

            <div class="item password">
              <input type="text" v-model="password" :placeholder="L['请输入验证码']" class="input" />
              <a href="javascript:void(0);" class="send_code" @click="getSmsCode">{{ countDownM ? (countDownM +
                L['s后获取']) : L['获取验证码'] }}</a>
            </div>
            <div class="error">
              <span v-if="errorMsg" style="color: #e1251b;font-size: 14px" class="iconfont icon-jubao"></span>
              {{ errorMsg }}
            </div>
            <a href="javascript:void(0)" @click="login" class="login_btn">{{ L['确认'] }}</a>
          </div>
        </div>
      </div>
    </div>

    <el-dialog v-model="bindedVisible" lock-scroll="false" width="480px" top="10%">
      <div class="bindMsg">
        <div class="msg_title">
          <img src="../../../assets/icon_mobile.png" alt />
          <p>{{ name }}</p>
        </div>
        <div class="msg_content">{{ L['该手机号已被绑定，请更换其他手机号'] }}</div>
        <div class="msg_tip">
          <p>{{ L['继续绑定：将解除与账号'] }}{{ binded }}{{ L['的绑定关系'] }}</p>
          <p>{{ L['更新信息：授权信息将绑定到账号'] }}{{ binded }}{{ L['上'] }}</p>
        </div>
        <div class="flex_row_center_center">
          <div class="go_bind_on" @click="confirmBind(2)">{{ L['继续绑定'] }}</div>
          <div class="go_bind_update" @click="confirmBind(3)">{{ L['更新信息'] }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { useRouter, onBeforeRouteLeave, useRoute } from "vue-router";
  import { ref, getCurrentInstance, onMounted, watch, onUnmounted } from "vue";
  import { useStore } from "vuex";
  import { ElMessage } from "element-plus";
  import areaData from "../../../assets/area.json";
  import { h5CaptchaAppId } from "../../../utils/config"
  export default {
    name: "LoginIndex",
    setup() {
      const store = useStore();
      const keyEnter = ref(true);
      const errorMsg = ref(); //错误提示
      const password = ref(""); //密码
      const loginType = ref(1); //登陆类型：1-账号密码登陆，2-手机验证码登陆
      const router = useRouter();
      const route = useRoute();
      const { proxy } = getCurrentInstance();
      const L = proxy.$getCurLanguage();
      const current = ref("");
      const countDownM = ref(0); //短信验证码倒计时
      const timeOutId = ref(""); //定时器的返回值
      const configInfo = ref(store.state.configInfo);
      const bindedVisible = ref(false);
      const companyName = ref(""); //单位名称
      const addressAll = ref(""); //所在地
      const cascaderProps = { label: "regionName", value: "regionCode" };
      const detailAddress = ref(""); //详细地址
      const provinceCode = ref(""); //省市编码
      const cityCode = ref(""); //城市编码
      const districtCode = ref(""); //地区编码
      const areaDataArray = areaData;
      const name = ref(""); //手机号
      const Email = ref('');
      const user_name = ref('');
      const cascaderAddr = ref(null);
      const defaultImg = ref(
        'this.src="' + require("../../../assets/common_top_logo.png") + '"'
      );
      const defaultBgImg = ref(
        'this.src="' + require("../../../assets/login_bg.png") + '"'
      );
      const wxEnable = ref("");
      const captchaInstance = ref(null)
      //由于这里的回车键触发事件和商品搜索框的回车键触发事件冲突，引入keyEnter变量判断
      document.onkeydown = function () {
        var key = window.event.keyCode;
        if (key == 13 && keyEnter.value) {
          login();
        }
      };
      const binded = ref("");
      const bindType = ref(1);
      const preventFre = ref(false);

      const login = () => {
        //   let param = {};
        //   param.mobile = name.value;
        //   param.bindType = bindType.value;
        //   param.smsCode = password.value;
        //   param.resource = 1;
        //   param.bindKey = route.query.code;
        //   //手机号验证
        //   if (!param.mobile) {
        //     errorMsg.value = L["请输入手机号"];
        //     return false;
        //   } else {
        //     let checkMobile = proxy.$checkPhone(param.mobile);
        //     if (checkMobile !== true) {
        //       errorMsg.value = checkMobile;
        //       return false;
        //     }
        //   }

        //   //验证码校验
        //   if (!param.smsCode) {
        //     errorMsg.value = L["请输入短信验证码"];
        //     return false;
        //   } else {
        //     let checkSmsCode = proxy.$checkSmsCode(param.smsCode);
        //     if (checkSmsCode !== true) {
        //       errorMsg.value = checkSmsCode;
        //       return false;
        //     }
        //   }
        // 验证
        if (!companyName.value) return (errorMsg.value = "请输入单位全称");
        if (!addressAll.value) return (errorMsg.value = "请选择所在地区");
        if (!detailAddress.value) return (errorMsg.value = "请输入详细信息");
        let param = {};
        param.memberTrueName = user_name.value;
        param.memberEmail = Email.value;
        param.bindType = bindType.value;
        param.phone = name.value;
        param.code = password.value;
        param.companyName = companyName.value;
        param.bindKey = route.query.code;
        param.detailAddress = detailAddress.value;
        param.addressAll = cascaderAddr.value
          .getCheckedNodes()[0]
          .pathLabels.join("");
        param.provinceCode = addressAll.value[0];
        param.cityCode = addressAll.value[1];
        param.districtCode = addressAll.value[2];
        param.source = 1;
        //手机号验证
        if (!param.phone) {
          errorMsg.value = L["请输入手机号"];
          return false;
        } else {
          let checkMobile = proxy.$checkPhone(param.phone);
          if (checkMobile != true) {
            errorMsg.value = checkMobile;
            return false;
          }
        }

        //验证码校验
        if (!param.code) {
          errorMsg.value = L["请输入短信验证码"];
          return false;
        } else {
          let checkSmsCode = proxy.$checkSmsCode(param.code);
          if (checkSmsCode !== true) {
            errorMsg.value = checkSmsCode;
            return false;
          }
        }
        //如果未登录vuex中有购物车数据，需同步到该用户
        let cartInfo = [];
        let cartListData = store.state.cartListData;
        if (JSON.stringify(cartListData) != "{}") {
          // cartListData.storeCartGroupList.map(cartListItem => {
          //     cartListItem.promotionCartGroupList.map(promotItem => {
          //         promotItem.cartList.map(cartItem => {
          //             cartInfo.push({
          //                 productId: cartItem.productId,
          //                 buyNum: cartItem.buyNum
          //             });
          //         });
          //     });
          // });
          cartListData.promotionCartGroupList.map(promotItem => {
            promotItem.cartList.map(cartItem => {
              cartInfo.push({
                productId: cartItem.productId,
                buyNum: cartItem.buyNum
              });
            });
          });
          param.cartInfo = JSON.stringify(cartInfo);
        }
        proxy
          .$post("v3/member/front/login/wechat/bindMobile", param)
          .then(res => {
            if (res.state == 200) {
              //将用户信息存缓存，并跳转到首页
              localStorage.setItem("access_token", res.data.access_token);
              localStorage.setItem("refresh_token", res.data.refresh_token);
              localStorage.setItem("time", new Date().getTime().toString()); //存储refresh_token更新时间

              //获取用户信息，并同步信息到vuex
              proxy.$get("v3/member/front/member/getInfo").then(res => {
                if (res.state == 200) {
                  store.commit("updateMemberInfo", res.data);
                  proxy.$getLoginCartListData(); //更新购物车数据
                  proxy.$sldStatEvent({ behaviorType: "reg" });
                  ElMessage.success(res.msg);
                  setTimeout(() => {
                    router.replace({ path: "/member/index" });
                  }, 1000);
                }
              });
            } else if (res.state == 267) {
              binded.value = res.data;
              bindedVisible.value = true;
            } else {
              //提示错误
              errorMsg.value = res.msg;
            }
          });
      };
      //清空输入框内容
      const clearInputVal = type => {
        if (type == "name") {
          name.value = "";
        } else if (type == "password") {
          password.value = "";
        }
      };

      watch([name, password], () => {
        let checkSmsCode = proxy.$checkSmsCode(password.value);
        let checkMobile = proxy.$checkMobile(name.value);
        name.value = name.value.toString().substring(0, 11);
        password.value = password.value.toString().substring(0, 6);
        if (name.value || password.value) {
          errorMsg.value = "";
        }
      });

      const confirmBind = type => {
        bindType.value = type;
        login();
      };

      //获取短信验证码
      const getSmsCode = () => {
        if (preventFre.value) {
          return;
        } else if (countDownM.value) {
          return;
        }
        preventFre.value = true;
        let checkMobile = proxy.$checkPhone(name.value);
        let checkCode = proxy.$checkSmsCode(password.value);
        if (checkMobile !== true) {
          errorMsg.value = checkMobile;
          preventFre.value = false;
          return false
        }
        showCaptcha()
        return
        let param = {};
        param.mobile = name.value;
        param.type = "wxAuth";
        proxy.$get("v3/msg/front/commons/smsCode", param).then(res => {
          if (res.state == 200) {
            countDownM.value = 60;
            countDown();
            preventFre.value = false;
          } else {
            //提示错误
            errorMsg.value = res.msg;
            preventFre.value = false;
          }
        });
      };
      //倒计时
      const countDown = () => {
        countDownM.value--;
        if (countDownM.value == 0) {
          preventFre.value = false;
          clearTimeout(timeOutId.value);
        } else {
          timeOutId.value = setTimeout(countDown, 1000);
        }
      };
      //通过replace方式跳转页面
      const goToPage = type => {
        router.replace({
          path: type
        });
      };
      const showClose = cur => {
        current.value = cur;
      };
      const delateInput = type => {
        switch (type) {
          case "companyName":
            companyName.value = "";
            break;
          case "addressAll":
            addressAll.value = "";
            break;
          case "detailAddress":
            detailAddress.value = "";
            break;
          case "name":
            name.value = "";
            break;
        }
      };
      onMounted(() => {
        loadCaptchaScript()
      });

      const loadCaptchaScript = () => {
        return new Promise((resolve, reject) => {
          // 检查脚本是否已加载
          if (window.TencentCaptcha) {
            resolve();
            return;
          }

          // 创建script标签加载验证码脚本
          const script = document.createElement('script');
          script.src = 'https://turing.captcha.qcloud.com/TJCaptcha.js';
          script.type = 'text/javascript';
          script.onload = resolve;
          script.onerror = () => reject(new Error('验证码脚本加载失败'));
          document.head.appendChild(script);
        });
      }
      const showCaptcha = () => {
        return new Promise((resolve, reject) => {
          // 创建验证码实例
          captchaInstance.value = new window.TencentCaptcha(
            h5CaptchaAppId,
            (res) => {
              // 验证码回调结果处理
              if (res.ret === 0) {
                // 验证成功，获取ticket和randstr
                verifyWithServer(res.ticket, res.randstr)
                  .then(res => {
                    resolve(res)
                  })
                  .catch(err => {
                    reject(err)
                  });
              } else {
                console.log(res, '1111111')
                // 验证失败
                reject(new Error(getErrorMsg(res.ret)));
              }
            }, {
            // 验证码配置
            type: 'popup', // 嵌入式展示
            container: 'captchaContainer', // 容器ID
            theme: 'white', // 主题
            lang: 'zh-cn', // 语言
            showFn: (ret) => {
              console.log('showFn', ret)
            }
          }
          );

          // 显示验证码
          captchaInstance.value.show();
        });
      }
      const verifyWithServer = (ticket, randstr) => {
        let param = {};
        param.mobile = name.value;
        param.type = "wxAuth";
        param.ticket = ticket;
        param.randstr = randstr;
        proxy.$get("v3/msg/front/commons/smsCode", param).then(res => {
          if (res.state == 200) {
            countDownM.value = 60;
            countDown();
            preventFre.value = false;
          } else {
            //提示错误
            errorMsg.value = res.msg;
            preventFre.value = false;
          }
        });
      }
      onUnmounted(() => {
        if (captchaInstance.value) {
          captchaInstance.value.destroy()
        }
      })

      return {
        L,
        showClose,
        loginType,
        delateInput,
        login,
        name,
        password,
        clearInputVal,
        errorMsg,
        getSmsCode,
        countDownM,
        goToPage,
        configInfo,
        defaultImg,
        defaultBgImg,
        wxEnable,
        bindedVisible,
        binded,
        confirmBind,
        companyName,
        addressAll,
        detailAddress,
        provinceCode,
        cityCode,
        districtCode,
        current,
        areaDataArray,
        cascaderProps,
        user_name,
        Email,
        cascaderAddr,
        captchaInstance,
        loadCaptchaScript,
        showCaptcha,
        verifyWithServer
      };
    }
  };
</script>
<style lang="scss" scoped>
  // @import "../../../style/login.scss";
  @import "../../../style/register.scss";

  :deep(.item_cascader) {
    height: 30px !important;
    margin-top: -10px !important;
  }

  .el-popup-parent--hidden {
    overflow: visible;
  }

  .top .item1 {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    margin: 0 auto;

    &:after {
      display: none !important;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  .bindMsg {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .msg_title {
      display: flex;
      align-items: center;

      p {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-left: 26px;
      }

      img {
        width: 50px;
        height: 50px;
      }
    }

    .msg_content {
      margin-top: 30px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
    }

    .msg_tip {
      margin-top: 12px;
      line-height: 20px;
    }

    .go_bind_on {
      margin-top: 30px;
      width: 120px;
      height: 36px;
      background: #fc1c1c;
      border-radius: 3px;
      color: #fff;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
    }

    .go_bind_update {
      margin-left: 20px;
      margin-top: 30px;
      width: 120px;
      height: 36px;
      background: #999;
      border-radius: 3px;
      color: #fff;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
    }
  }
</style>